export default __webpack_public_path__ + "static/project2-acce49456f568b13c9fbf644470e6498.jpg";